import React, { Component } from 'react';
import { Button, Card, message, Table } from 'antd';
import { connect } from 'react-redux';

import {
  queryAdminAccountInfo,
  queryAdminAccountList,
  querySaveAccount,
  querySaveAccountOrg,
  querySaveAccountRole,
} from '@api/core/user';
import ComponentOrg from './ComponentOrg';
import ModalUserAdd from './ModalUserAdd';
import ModalUserOrgAdd from './ModalUserOrgAdd';
import ModalUserRoleAdd from './ModalUserRoleAdd';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      orgUuid: '',
      total: 0,
      pageNo: 1,
      isPermission: false,
      dataInfo: null,
      visible: false,
      orgVisible: false,
      roleVisible: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.loadData(1);
    this.judge(this.props.account_info);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.account_info !== nextProps.account_info) {
      this.judge(nextProps.account_info);
    }
  }

  loadData = pageNo => {
    const { orgUuid } = this.state;
    if (orgUuid) {
      const params = { orgUuid };
      const no = this.state.pageNo;
      const current = pageNo || no;
      params.limit = 15;
      params.start = current;
      this.setState({
        pageNo: current,
        isLoading: true,
      });
      queryAdminAccountList(params).then(res => {
        if (res.statusCode === 200) {
          this.setState({ data: res.data, total: res.totalSize, isLoading: false });
        } else {
          message.error(res.message);
        }
      });
    }
  };

  loadUserInfo = (uuid, callback) => {
    queryAdminAccountInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({ dataInfo: res.data }, callback);
      }
    });
  };

  saveUser = params => {
    querySaveAccount(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handlerVisible(false);
        this.loadData(1);
      } else {
        message.error(res.message);
      }
    });
  };

  saveUserRole = (accountUuid, roleUuids) => {
    querySaveAccountRole({ accountUuid, roleUuids }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handlerRoleVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  saveUserOrg = params => {
    querySaveAccountOrg(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handlerOrgVisible(false);
        this.loadData(this.state.pageNo);
      } else {
        message.error(res.message);
      }
    });
  };

  judge = accountInfo => {
    let isPermission = false;
    if (accountInfo.admin) {
      isPermission = true;
    }

    this.setState({
      isPermission,
    });
  };

  add = () => {
    this.setState({ dataInfo: null });
    this.handlerVisible(true);
  };

  edit = uuid => {
    this.loadUserInfo(uuid, () => this.handlerVisible(true));
  };

  editRole = uuid => {
    this.loadUserInfo(uuid, () => this.handlerRoleVisible(true));
  };

  editOrg = uuid => {
    this.loadUserInfo(uuid, () => this.handlerOrgVisible(true));
  };

  handlerVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  handlerRoleVisible = flag => {
    this.setState({
      roleVisible: !!flag,
    });
  };

  handlerOrgVisible = flag => {
    this.setState({
      orgVisible: !!flag,
    });
  };

  handleOrgChange = value => {
    if (Array.isArray(value) && value.length > 0) {
      this.setState({ orgUuid: value[0] }, () => this.loadData(1));
    } else {
      this.setState({ orgUuid: value }, () => this.loadData(1));
    }
  };

  columns = () => [
    {
      title: '默认机构名称',
      dataIndex: 'orgName',
      key: 'orgName',
    },
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '账户代码',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: '手机号码',
      dataIndex: 'mobile',
      key: 'mobile',
    },
    {
      title: '状态',
      dataIndex: 'status',
      render: text => {
        return <span>{text === 1 ? '启用' : '禁用'}</span>;
      },
    },
    {
      title: '编辑',
      key: 'done',
      render: (rext, record) => {
        const { isPermission } = this.state;
        return isPermission ? (
          <span>
            <a onClick={() => this.edit(record.uuid)}>编辑</a>
            <span className="ant-divider" />
            <a onClick={() => this.editRole(record.uuid)}>角色授权</a>
            <span className="ant-divider" />
            <a onClick={() => this.editOrg(record.uuid)}>机构设置</a>
          </span>
        ) : null;
      },
    },
  ];

  render() {
    const { data, orgUuid, isLoading, total, pageNo, visible, orgVisible, roleVisible, dataInfo } =
      this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };

    return (
      <Card>
        <div style={{ display: 'flex' }} className="pageStaff">
          <div style={{ width: '350px', marginRight: '16px' }}>
            <ComponentOrg handleChange={this.handleOrgChange} />
          </div>
          <div style={{ flex: 1 }}>
            <Button type="primary" icon="plus" style={{ marginBottom: 15 }} onClick={this.add}>
              添加
            </Button>
            <Table
              rowKey={record => record.uuid}
              loading={isLoading}
              columns={this.columns()}
              dataSource={data}
              pagination={pagination}
            />

            <ModalUserAdd
              visible={visible}
              orgUuid={orgUuid}
              data={dataInfo}
              onOk={params => this.saveUser(params)}
              onCancel={() => this.handlerVisible(false)}
            />

            <ModalUserRoleAdd
              visible={roleVisible}
              accountUuid={dataInfo ? dataInfo.uuid : ''}
              onOk={targetKeys => this.saveUserRole(dataInfo ? dataInfo.uuid : '', targetKeys)}
              onCancel={() => this.handlerRoleVisible(false)}
            />

            <ModalUserOrgAdd
              visible={orgVisible}
              accountUuid={dataInfo ? dataInfo.uuid : ''}
              defaultOrgUuid={dataInfo ? dataInfo.orgUuid : ''}
              onOk={params => this.saveUserOrg(params)}
              onCancel={() => this.handlerOrgVisible(false)}
            />
          </div>
        </div>
      </Card>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
  account_info: state.account_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/boss/user/Index.js